<template>
  <div class="page_container price" :class="{ isModalOpen: clickAlarm }">
    <div class="page_inner">
      <!-- <div class="Tb_alram_01"></div> -->
      <div class="page_content mt20">
        <!-- 코인 리스트 api 불러오는 동안 로딩바  start-->
        <div class="subPage_container" v-if="!lodingStatus">
          <div class="loading_spinner">
            <div class="loading_circle"></div>
          </div>
        </div>
        <!-- 코인 리스트 api 불러오는 동안 로딩바 end -->

        <!-- userPackage 1000 이하 && 패키지 3000 이하면서 알람 미구매시 -->
        <div class="ps_nodata mt110s" v-else-if="Number(userPackage) < 1000 || !alarmPayment">
          <h4>{{ $t('alarm.guideMent.access1') }}<br />{{ $t('alarm.guideMent.access2') }}</h4>
        </div>
        
        <!--알람>시세 Data 리스트-->
        <div class="Tb_alarm_data_01" v-else-if="!noData">
          <ul>
            <li v-for="(group, index) in groupedAlarmList" :key="index">
              <div class="alram_coin_wrap">
                <div class="coin_info">
                  <div class="coin_img">
                    <img :src="getImagePath(group.coin)" />
                  </div>
                  <div class="coin_name">
                    <h5>
                      {{ group.coin }}<span>/{{ group.quote }}</span>
                    </h5>
                  </div>
                </div>
                <div class="btn_alram_add" @click="addGroupAlarm(group.coin, group.quote)">
                  알람추가
                </div>
              </div>
              <div class="alarm_set_wrap">
                <ul>
                  <li v-for="(alarm, i) in group.alarms" :key="`alarm-${i}`">
                    <div class="alarm_set_price">
                      <div class="alarm-set-price-content top">
                        <h6 class="exch">{{ alarm.exchange }}</h6>
                        <h2 class="num" :class="getClass(alarm.type)">
                          {{ convertPrice(alarm.price, alarm.quote) }}
                        </h2>
                      </div>
                      <div class="alarm-set-price-content bottom" :class="locale">
                        <div>
                          {{ $t(`alarm.price.${alarm.type}`) }}
                        </div>
                        <div>
                          {{ translateCycle(alarm.cycle) }}
                        </div>
                      </div>
                    </div>
                    <div class="alarm_btn">
                      <div class="btn_alarm_box">
                        <input type="checkbox" :id="`alramChk_${alarm.id}`" :name="`alramChk_${alarm.id}`"
                          :checked="alarm.active" @click="msgEl" /><label :for="`alramChk_${alarm.id}`"
                          @click="activeAlarm(alarm.id, alarm.active)"></label>
                      </div>
                      <div class="btn_alarm_modify" @click="editAlarm(alarm.id)">
                        수정
                      </div>
                      <div class="btn_alarm_delete" @click="sendDelPriceAlarm(alarm.id)">
                        삭제
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="nodata" v-else-if="noData">
          {{ $t('alarm.price.noData3') }}
        </div>
      </div>
    </div>
  </div>
  <!-- {{ $t('header["up"]') }} -->
  <AlarmRegModal ref="AlarmRegModal" v-if="clickAlarm" @update-alarms="handleUpdateAlarms" />
</template>

<script>
import AlarmRegModal from "@/components/modal/AlarmRegModal.vue";
//   import AlarmRegModalCopy from "@/components/modal/AlarmRegModalCopy.vue";
import { msgEl } from "@/utils/modalText.js";
import { watch } from 'vue';
import { useI18n } from "vue-i18n";

// import {fetchPriceFavorites} from '@/api/alarmActive';
import {
  getPriceAlarm,
  delPriceAlarm,
  activePriceAlarm,
} from "@/api/priceAlarmApi";
import router from "@/routes";
import { convertPrice, formatPriceChange } from "@/utils/priceFormat.js";
import { getImagePath } from "@/utils/getCoinImage";
import { mapState, mapMutations } from "vuex";
import { chkPermission } from "@/utils/permission.js";

export default {
  name: "PriceAlarm",
  components: {
    AlarmRegModal,
  },
  setup() {
    const { locale } = useI18n();

    watch(locale, (newlocale) => {
      localStorage.setItem("locale", newlocale);
    });

    return {
    locale,
    };
},
  watch: {
    async loginSuccessful(newVal) {
      if (newVal === true) {
        await this.getPermission();

        getPriceAlarm().then((response) => {
          // console.log(response.data);
          if (response.data.isSuccess == true) {
            this.priceAlarmList = response.data.data;
            // console.log("priceAlarmList", this.priceAlarmList.length);
            if (this.priceAlarmList.length < 1) {
              this.noData = true;
            }
            this.priceAlarmListOriginal = [...this.priceAlarmList];
            this.groupedAlarmList = this.groupAlarmsByExchangeCoinQuote(
              this.priceAlarmList
            );
            // console.log("this.groupedAlarmList", this.groupedAlarmList);
            this.loadSuccess();
          }
        });
      }
    },
  },
  // emits: ['update-alarms'],
  // mounted() {
  //   // console.log('window', window)
  //   window.addEventListener('popstate', this.handleBack);
  // },
  // beforeUnmount() {
  //   window.removeEventListener('popstate', this.handleBack);
  // },
  methods: {
    ...mapMutations("alarmReg", [
      "changeAlarm",
      "editAlarmState",
      "priceTotal",
      "updateGroupAlarm",
    ]),
    msgEl,
    convertPrice,
    formatPriceChange,
    getImagePath,
    delPriceAlarm,
    getPriceAlarm,
    activePriceAlarm,

    loadSuccess() {
      if (window.webkit && window.webkit.messageHandlers.loadHandler) {
        window.webkit.messageHandlers.loadHandler.postMessage('Load state changed.');
      }

      if (window.Android) {
        window.Android.loadTriggered();
      }

      // // console.log("Load success triggered!");
    },

    getClass(type) {
      if (type == "UP") {
        return "txt_plus";
      } else if (type == "DOWN") {
        return "txt_minus";
      } else {
        return "";
      }
    },
    groupAlarmsByExchangeCoinQuote(alarms) {
      const grouped = {};
      alarms.forEach((alarm) => {
        const key = `${alarm.coin}-${alarm.quote}`;
        if (!grouped[key]) {
          grouped[key] = {
            coin: alarm.coin,
            quote: alarm.quote,
            alarms: [alarm],
          };
        } else {
          grouped[key].alarms.push(alarm);
        }
      });
      return Object.values(grouped);
    },
    updateAlarmList() {
      // 각 알람들 삭제,업데이트시 배열 재생성
      this.getPriceAlarm().then((response) => {
        // // console.log(response.data);
        if (response.data.isSuccess == true) {
          this.priceAlarmList = response.data.data;
          // // console.log("priceAlarmList", this.priceAlarmList.length);
          if (this.priceAlarmList.length < 1) {
            this.noData = true;
          } else {
            this.noData = false;
          }
          this.priceAlarmListOriginal = [...this.priceAlarmList];
          this.groupedAlarmList = this.groupAlarmsByExchangeCoinQuote(
            this.priceAlarmList
          );
          console.log("this.groupedAlarmList", this.groupedAlarmList);
        }
      });
    },
    // 알람삭제
    sendDelPriceAlarm(id) {
      this.delPriceAlarm(id).then((response) => {
        // // console.log(response);
        if (response.data.isSuccess == true) {
          // // console.log("del success");
          this.updateAlarmList();
        }
      });
    },
    handleUpdateAlarms() {
      // // console.log("저장클릭", data);
      this.updateAlarmList();
    },
    activeAlarm(id, active) {
      // // console.log(id, active);
      this.activePriceAlarm(id, active).then((response) => {
        // // console.log(response.data.data);
        if (response.data.isSuccess == true) {
          this.updateAlarmList();
        }
      });
    },
    editAlarm(id) {
      let editAlarm = this.priceAlarmListOriginal.find((el) => el.id == id);
      // // console.log("editAlarm", editAlarm);
      // this.changeAlarm({ state: true });
      router.push('/alarm/change-coin')
      this.priceTotal({ setPrice: editAlarm.price });
      this.editAlarmState({
        ...editAlarm,
        // currentPrice: editAlarm.price,
        // price: editAlarm.price, // 지정가격
        percent: null,
        edit: true,
      });
    },
    addGroupAlarm(coin, quote) {
      // 같은 코인 추가
      // this.changeAlarm({ state: true });
      this.updateGroupAlarm({
        ...this.alarmRegInfo,
        coin: coin,
        quote: quote,
        edit: true,
        sameGroup: true,
      });
      router.push('/alarm/change-coin')

    },
    translateCycle(cycle) {
      if (cycle == "ONCE" || cycle == "DAY_1") {
        return this.$t(`alarm.price.${cycle}`)
      } else if (cycle.split("_")[0] == "MINUTE") {
        return this.$t(`alarm.price.${cycle.split("_")[0]}`, { minute: cycle.split("_")[1] })
      } else if (cycle.split("_")[0] == "HOUR") {
        return this.$t(`alarm.price.${cycle.split("_")[0]}`, { hour: cycle.split("_")[1] })
      }
    },
    async getPermission() {
      const result = await chkPermission();

      this.permission = result.permission;
      this.alarmPayment = result.alarmPayment;
      this.userPackage = result.userPackage;

      // console.log('userPackage', this.userPackage)
      this.lodingStatus = true;
    }
  },
  computed: {
    ...mapState("alarmReg", ["clickAlarm", "alarmRegInfo"]),
    loginSuccessful() {
      return this.$store.state.loginStatus.loginSuccessful;
    }
  },
  data() {
    return {
      priceAlarmListOriginal: null,
      priceAlarmList: null,
      sameAlarmList: [],
      eachAlarmList: [],
      groupedAlarmList: null,
      noData: false,
      lodingStatus: false,
      permission: false,
      alarmPayment: false,
      userPackage: 0,
    };
  },
  async beforeMount() {
    await this.getPermission();

    getPriceAlarm().then((response) => {
      // // console.log(response.data);
      if (response.data.isSuccess == true) {
        this.priceAlarmList = response.data.data;
        // // console.log("priceAlarmList", this.priceAlarmList.length);
        if (this.priceAlarmList.length < 1) {
          this.noData = true;
        }
        this.priceAlarmListOriginal = [...this.priceAlarmList];
        this.groupedAlarmList = this.groupAlarmsByExchangeCoinQuote(
          this.priceAlarmList
        );
        // console.log("this.groupedAlarmList", this.groupedAlarmList);
        this.loadSuccess();
      }
    });
  },
  // watch:{
  //     groupedAlarmList: {
  //         deep: true, // 객체 내부까지 감시하려면 deep 옵션을 true로 설정합니다.
  //         handler() {
  //             // priceAlarmList가 변경될 때마다 실행할 로직
  //             this.getPriceAlarm();
  //         },
  //     },
  // }
};
</script>